"use strict";

exports.__esModule = true;
exports.canResizeElement = canResizeElement;
var _getElementsInPath = require("./getElementsInPath");
var _getWidget = require("./getWidget");
var _isSupportedWidgetProperty = require("./isSupportedWidgetProperty");
/**
 * Determine whether the element at the given path is resizable.
 */
function canResizeElement(widgets, root, path) {
  var elements = (0, _getElementsInPath.getElementsInPath)(root, path);
  if (elements.length === 0) {
    return false;
  }
  var element = elements[elements.length - 1];
  var widget = (0, _getWidget.getWidget)(widgets, element.type);
  if (!widget || !(0, _isSupportedWidgetProperty.isSupportedWidgetProperty)(widget, "width")) {
    return false;
  }
  if (elements.length > 1) {
    var parentWidget = (0, _getWidget.getWidget)(widgets, elements[elements.length - 2].type);
    if (parentWidget !== undefined && parentWidget.suppliesProps.includes("width")) {
      return false;
    }
  }
  return true;
}